export const RentAdvanceRoutes = {
    path: 'rentAdvance',
    explain: {
        path: 'explain',
    },
};
